export interface BasePalette {
  brandBackground?: string;
  brandText?: string;
  brandOutlinedText?: string;
  navbarBackgroundColor?: string;
  navbarItemColor?: string;
  dangerButtonBackgroundColor?: string;
}
